export default __webpack_public_path__ + "static/media/OtherProjectImage.9cb2ae57.png";